import type { TItem, TSparseItem } from '@modules/items';

export { EDashboardReviewState, EDashboardWorkflow } from '@modules/items/types/itemClassification.types';

export type TDashboardTone = 'danger' | 'warning' | 'success' | 'info' | 'neutral';

export enum EDashboardSegmentKey {
  OPEN_APPROVAL = 'open-approval',
  DRAFT = 'draft',
  NOT_APPROVED = 'not-approved',
  APPROVED = 'approved',
  OVERDUE_REVIEWS = 'overdue-reviews',
  REVIEWS_DUE_SOON = 'reviews-due-soon',
}

export type TDashboardActiveApproval = {
  dateOpened: string;
};

export type TDashboardSegmentItem = {
  item: TItem;
  root: TSparseItem;
  activeApproval?: TDashboardActiveApproval;
};

export type TDashboardCounters = {
  notApproved: number;
  openApprovals: number;
  draft: number;
  approved: number;
  periodicReviews: {
    active: number;
    overdue: number;
    dueSoon: number;
  };
};

export type TDashboardSegmentSummary = {
  key: EDashboardSegmentKey;
  totalCount: number;
};

export type TDashboardScopeResponse = {
  selectedRootIds: string[];
};

export type TDashboardOverviewResponse = {
  scope: TDashboardScopeResponse;
  counters: TDashboardCounters;
  rootOptions: TSparseItem[];
};

export type TDashboardSegmentPageResponse = {
  scope: TDashboardScopeResponse;
  segment: TDashboardSegmentSummary & {
    items: TDashboardSegmentItem[];
    page: number;
    pageSize: number;
  };
};

export type TDashboardViewCounters = {
  overdueReviews: number;
  reviewsDueSoon: number;
  openApprovals: number;
  reviewActive: number;
  draft: number;
  notApproved: number;
  approved: number;
};

export type TDashboardMetric = {
  segmentKey: EDashboardSegmentKey;
  title: string;
  value: number;
  caption: string;
  tone: TDashboardTone;
};

export type TDashboardStatusChartId = 'draft' | 'reviewActive' | 'openApprovals' | 'notApproved' | 'approved';

export type TDashboardStatusChartDatum = {
  key: TDashboardStatusChartId;
  label: string;
  value: number;
  color: string;
};

export type TDashboardSegmentView = {
  key: EDashboardSegmentKey;
  label: string;
  totalCount: number;
};

export type TDashboardSegmentPageView = TDashboardSegmentView & {
  items: TDashboardSegmentItem[];
  page: number;
  pageSize: number;
};

export type TDashboardViewModel = {
  counters: TDashboardViewCounters;
  rootOptions: TSparseItem[];
  segments: TDashboardSegmentView[];
  statusChart: TDashboardStatusChartDatum[];
};
